var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceivedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.8307C7.02283 12.8307 6.56667 12.6411 5.65492 12.2626C3.38517 11.3199 2.25 10.8486 2.25 10.0558V4.51531M7.5 12.8307C7.97717 12.8307 8.43333 12.6411 9.34508 12.2626C11.6148 11.3199 12.75 10.8486 12.75 10.0558V4.51531M7.5 12.8307V7.09598M2.25 4.51531C2.25 4.86706 2.71783 5.0899 3.65292 5.5344L5.35625 6.34523C6.40917 6.84573 6.93417 7.09598 7.5 7.09598M2.25 4.51531C2.25 4.16298 2.71783 3.94015 3.65292 3.49565L4.875 2.91406M12.75 4.51531C12.75 4.86706 12.2822 5.0899 11.3471 5.5344L9.64375 6.34523C8.59083 6.84573 8.06583 7.09598 7.5 7.09598M12.75 4.51531C12.75 4.16298 12.2822 3.94073 11.3471 3.49623L10.125 2.91406M7.50233 1.16406V5.2474M7.50233 5.2474C7.65575 5.24973 7.80683 5.1424 7.91883 5.01115L8.66667 4.1169M7.50233 5.2474C7.35417 5.24565 7.20425 5.1389 7.08583 5.01115L6.33333 4.1169",
    stroke: "#FCFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedIcon);
export default __webpack_public_path__ + "static/media/ReceivedIcon.df975db23ff4cc8cb475c926ef6aff5c.svg";
export { ForwardRef as ReactComponent };